enum SortableColumns {
  ClientName = 'ClientName',
  LocationGroup = 'LocationGroup',
}

export const locationGroupsColumns = [SortableColumns.ClientName, SortableColumns.LocationGroup];

export default SortableColumns;
